import request from '@/utils/request'

// 查询试驾订车订单分页
export function pageCarOrder(query) {
  return request({
    url: '/carOrder/carOrder/page',
    method: 'get',
    params: query
  })
}

// 查询试驾订车订单列表
export function listCarOrder(query) {
  return request({
    url: '/carOrder/carOrder/list',
    method: 'get',
    params: query
  })
}

// 删除试驾订车订单
export function delCarOrder(data) {
  return request({
    url: '/carOrder/carOrder/delete',
    method: 'post',
    data: data
  })
}
